import type { FC, PropsWithChildren } from "react";

import { PageLayoutContainer, PageLayoutScrollableContainer } from "./PageLayoutStyles";

export type PageProps = {
    name?: string;
    scrollable?: boolean;
} & PropsWithChildren;

export const PageLayout: FC<PageProps> = ({ name, scrollable, children }) => {
    const Container = scrollable ? PageLayoutScrollableContainer : PageLayoutContainer;

    return <Container data-name={name}>{children}</Container>;
};
